<script>
export default {
	name: 'CookieBlocker',
	props: {
		types: {
			type: [Array, String],
			default() {
				return ['functional', 'statistic', 'marketing'];
			},
		},
	},
	data() {
		return {
			currentConsent: {
				functional: null,
				statistic: null,
				marketing: null,
			},
		};
	},
	computed: {
		serviceAvailable() {
			return typeof window !== 'undefined' ? !!window.CookieInformation : false;
		},
		blockIncomingElement() {
			const missingCookies = this.missingCookies.length;

			if (this.$isDev) {
				return false; // Force a state while developing
			}

			// If the service is not available, or cookie acceptance is not fullfilled, block the element
			return !this.serviceAvailable || missingCookies;
		},
		missingCookies() {
			let cookies = this.types;
			if (typeof cookies === 'string' || cookies instanceof String) {
				cookies = [cookies];
			}
			return cookies.filter(cookie => !this.currentConsent[cookie]);
		},
		mappedMissingCookies() {
			// Simply for translations and prettyfications of the words
			return this.missingCookies.map((cookie) => {
				switch (cookie) {
				case 'functional':
					return 'Funktionelle';
				case 'statistic':
					return 'Statistiske';
				case 'marketing':
					return 'Marketing';
				default:
					return cookie;
				}
			});
		},
	},
	mounted() {
		this.currentConsent.functional = window.CookieInformation.getConsentGivenFor(
			'cookie_cat_functional',
		);
		this.currentConsent.statistic = window.CookieInformation.getConsentGivenFor(
			'cookie_cat_statistic',
		);
		this.currentConsent.marketing = window.CookieInformation.getConsentGivenFor(
			'cookie_cat_marketing',
		);
		// This event tells us when cookie consent has been updated
		window.addEventListener(
			'CookieInformationConsentGiven',
			this.updateConsents,
		);
	},
	destroyed() {
		window.removeEventListener(
			'CookieInformationConsentGiven',
			this.updateConsents,
		);
	},
	methods: {
		openCookieBanner() {
			if (
				typeof window !== 'undefined' &&
				window.CookieConsent &&
				window.CookieConsent.show
			) {
				window.CookieConsent.show();
			} else {
				// The cookie banner does not work on localhost
				console.log(
					'The button has been triggered, but the banner cannot be shown currently.',
				);
			}
		},
		updateConsents() {
			this.currentConsent = {
				functional: window.CookieInformation.getConsentGivenFor(
					'cookie_cat_functional',
				),
				statistic: window.CookieInformation.getConsentGivenFor(
					'cookie_cat_statistic',
				),
				marketing: window.CookieInformation.getConsentGivenFor(
					'cookie_cat_marketing',
				),
			};
		},
	},
};
</script>

<template src="./cookie-blocker.html"></template>
<style src="./cookie-blocker.scss"></style>


// WEBPACK FOOTER //
// cookie-blocker.vue?220986e6